import type { Batch, LearningLanguage, Word } from '../types';

export function normalizeLearningLanguage(language?: LearningLanguage | null): LearningLanguage {
  return language === 'lt' ? 'lt' : 'pl';
}

export function supportsVerbPractice(language?: LearningLanguage | null): boolean {
  return ['pl', 'lt'].includes(normalizeLearningLanguage(language));
}

export function getLearningLanguageName(language?: LearningLanguage | null): string {
  return normalizeLearningLanguage(language) === 'lt' ? 'Lithuanian' : 'Polish';
}

export function getLearningLanguageShortLabel(language?: LearningLanguage | null): string {
  return normalizeLearningLanguage(language).toUpperCase();
}

export function getSourceWordLabel(word: Word, language?: LearningLanguage | null): string {
  const learningLanguage = normalizeLearningLanguage(language);
  return learningLanguage === 'lt' ? word.lt || word.pl : word.pl;
}

export function getBatchLearningLanguage(batch?: Batch | null): LearningLanguage {
  return normalizeLearningLanguage(batch?.learningLanguage);
}
